import React from 'react';

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	FormHelperText,
	Checkbox,
	Typography,
	FormGroup,
} from '@mui/material';

import { applyLayoutStyles } from '@/components/DynamicForm/layout.styles.handler';
import { CollectionInput, LayoutType } from '@/components/DynamicForm/types/DynamicFormTypes';
import { cssprefix } from '@/components/DynamicForm/utils/utils';
import { publish } from '@/components/DynamicForm/events';

import { dynamicFormCheckboxStyles } from '../FromElements.styles';

const MultiSelect: React.FC<CollectionInput> = ({
	errMsg,
	name,
	label,
	value = [],
	options = [],
	showError,
	layout,
	arrange,
	validations,
	reset,
}) => {
	const selectedValues = Array.isArray(value) ? value : [value];

	// Deprecated — remove once we exclusively use layout.arrange.
	const extendedLayout = arrange && !(layout as LayoutType)?.arrange ? { arrange } : layout;

	return (
		<FormControl data-testid={`${name}-multi-select`} component="fieldset" error={showError}>
			<FormLabel component="legend">
				<Typography color="text.primary" variant="header4">
					{label}
				</Typography>
			</FormLabel>
			<FormGroup sx={applyLayoutStyles({}, extendedLayout)}>
				{options.map(({ label: optLabel, value: optValue }, index) => (
					<FormControlLabel
						key={`${optValue}_${index}`}
						name={name}
						defaultValue={optValue}
						label={
							<Typography color="text.secondary" variant="bodyMediumBook">
								{optLabel}
							</Typography>
						}
						onChange={() => {
							publish('formDataUpdate', [name, optValue, validations, reset, 'multi-select']);
							publish('markInteracted', name);
						}}
						onBlur={() => publish('markInteracted', name)}
						control={
							<Checkbox
								className={`${cssprefix}checkbox`}
								checked={selectedValues.includes(optValue)}
								sx={dynamicFormCheckboxStyles.checkboxStyles}
							/>
						}
						sx={dynamicFormCheckboxStyles.formControlLabelStyles}
					/>
				))}
			</FormGroup>
			{errMsg && showError && <FormHelperText>{errMsg}</FormHelperText>}
		</FormControl>
	);
};

export default MultiSelect;
